<template>
  <div class="static-layout">
    <NavBar />
    <main>
      <slot />
    </main>
    <FooterBar />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
// Sticky-footer pattern: the wrapper fills at least one viewport height,
// `<main>` flexes to fill remaining space, so short pages (404, empty
// search results, etc.) don't leave the footer floating mid-screen.
.static-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  main {
    flex: 1 0 auto;
  }
}
</style>
